/* eslint-disable react/prop-types */
import { Link } from 'react-router-dom'
import { useSound } from '../lib/sound'
import Icon from './Icon'

const NAV = [
  { id: 'work', label: 'Work' },
  { id: 'about', label: 'About' },
  { id: 'contact', label: 'Contact' },
]

// The album's title strip: name, chapters, and the one red action, always in reach.
const Header = ({ theme, toggleTheme }) => {
  const [sound, toggleSound] = useSound()
  return (
    <header className='sticky top-0 z-40 border-b-stroke border-line bg-page'>
      <div className='mx-auto flex max-w-page items-center justify-between gap-2 px-gutter py-3 sm:gap-4'>
        <p>
          <Link
            to='/'
            className='whitespace-nowrap font-display text-[1.25rem] leading-none hover:text-sea sm:text-[clamp(1.75rem,2.5vw,2.25rem)] dark:hover:text-caption'
          >
            Nikita Yeldynov
          </Link>
        </p>

        <nav aria-label='Main' className='hidden md:block'>
          <ul className='lettering flex gap-7 text-[1.25rem]'>
            {NAV.map((item) => (
              <li key={item.id}>
                <Link to={`/#${item.id}`} className='underline-offset-[6px] hover:underline'>
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className='flex items-center gap-2'>
          <button
            type='button'
            aria-pressed={sound}
            aria-label='Sound effects'
            onClick={toggleSound}
            className='hidden size-11 place-items-center hover:text-sea sm:grid dark:hover:text-caption'
          >
            <Icon name={sound ? 'sound' : 'mute'} className='size-6' />
          </button>
          <button
            type='button'
            onClick={toggleTheme}
            aria-label={`Switch to ${theme === 'dark' ? 'day' : 'night'} theme`}
            className='grid size-11 place-items-center hover:text-sea dark:hover:text-caption'
          >
            <Icon name={theme === 'dark' ? 'sun' : 'moon'} className='size-6' />
          </button>
          <Link to='/#contact' className='btn-signal ml-1 px-3 text-base sm:px-5 sm:text-label'>
            <span className='sm:hidden'>Contact</span>
            <span className='hidden sm:inline'>Get in touch</span>
          </Link>
        </div>
      </div>
    </header>
  )
}

export default Header
